"use strict";

require("core-js/modules/es6.array.index-of");

exports.__esModule = true;
exports.IconRoot = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));

var _themes = require("./themes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var IconRoot = (
/*#__PURE__*/
0, _styledBase["default"])('svg', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['color', 'size'].indexOf(prop) === -1 && (0, _isPropValid["default"])(prop);
  },
  target: "edsisxk0"
})(function (_ref) {
  var color = _ref.color,
      rtl = _ref.rtl,
      size = _ref.size,
      baseTheme = _ref.theme;
  var theme = (0, _themes.iconTheme)(baseTheme);
  return {
    color: color,
    fill: theme.Icon_fill,
    fontSize: theme.fontSize_base,
    height: theme["Icon_size_" + size] || size,
    transform: theme.direction === 'rtl' && rtl && 'scaleX(-1)',
    width: theme["Icon_size_" + size] || size
  };
});
exports.IconRoot = IconRoot;